import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import useDatePicker, { Form, validate } from './hooks/useDatePicker'
import { Grid, Typography } from '@mui/material'
import Button from '../control/Button'
import DatePickerInput from '../component/input/DatePickerInput'

//Controller
const DatePickerPlayground = () => {
    const { onSubmit } = useDatePicker()
    const { t } = useTranslation()

    const validates = (values: Form) => {
        const validation = validate(values, t) || {}
        return validation
    }

    return (
        <Grid container>
            <Grid container>
                <Typography variant="h3" gutterBottom>
                    Control: Date Picker
                </Typography>
            </Grid>
            <Grid container>
                <FinalForm onSubmit={onSubmit} validate={validates}>
                    {({ handleSubmit, values }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Field
                                        name="startDate"
                                        label={'Start Date (required)'}
                                        component={DatePickerInput}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Field
                                        name="endEate"
                                        label={'End Date (disabled)'}
                                        component={DatePickerInput}
                                        disabled
                                    />
                                </Grid>
                                <Grid item md={12}>
                                    <Button color="primary" onClick={handleSubmit}>
                                        {t('BUTTON.SAVE')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </FinalForm>
            </Grid>
        </Grid>
    )
}

export default DatePickerPlayground
